module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container g-pt-50 g-pb-70"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-lg-3 g-mb-30"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav flex-column",
    attrs: {
      "role": "tablist",
      "data-target": "nav-5-3-primary-ver",
      "data-tabs-mobile-type": "slide-up-down",
      "data-btn-classes": "btn btn-md btn-block rounded-0 u-btn-outline-primary"
    }
  }, [_vm._l((_vm.items.keys()), function(group, index) {
    return (_vm.items != null) ? _c('li', {
      staticClass: "nav-item"
    }, [_c('a', {
      staticClass: "nav-link active g-brd-none g-color-main g-color-primary--hover g-px-0 g-py-5 g-font-size-20",
      attrs: {
        "data-toggle": "tab",
        "role": "tab"
      },
      on: {
        "click": function($event) {
          _vm.Scroll('#' + group.replace(/\s+/g, '') + '-div')
        }
      }
    }, [_vm._v("\r\n                  " + _vm._s(group) + "\r\n                ")])]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link g-brd-none g-color-main g-color-primary--hover g-px-0 g-py-5 g-font-size-20",
    attrs: {
      "data-toggle": "tab",
      "role": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.Scroll('#contactDiv')
      }
    }
  }, [_vm._v("\r\n                  Contact Us\r\n                ")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-9 g-mb-30"
  }, [_c('help-services'), _vm._v(" "), _c('help-center', {
    attrs: {
      "items": _vm.items
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-pb-10"
  }, [_c('h2', {
    staticClass: "mb-0"
  }, [_vm._v("FAQ Quick Links")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2f49931a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f49931a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/helpData/HelpBlock.vue
// module id = 485
// module chunks = 3